import { render, staticRenderFns } from "./StatusMantenimientos.vue?vue&type=template&id=7b2278aa&"
import script from "./StatusMantenimientos.vue?vue&type=script&lang=js&"
export * from "./StatusMantenimientos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports